class Rf {
  constructor() {
    this.init = false
    this._player = "rf"
    this._satellites = ["TURKSAT_42E", "HOTBIRD_13E", "ASTRA_19_2E"]
    this._polarization = { H: "POL_HL", V: "POL_VL" }
  }
  _init = async () => {
    tizen.tvchannel.addSignalStateChangeListener(state => state === "SIGNAL_STATE_OK" && _$.handler.emit("media_event", "play"))
    return true
  }

  start = async () => {
    return true
  }
  destroy = async () => {
    return this.stop()
  }
  play = async () => {
    const promise = await _$.progress.create()
    if (promise.isResolved) return false

    this.closeSubtitle()

    _$.vue.$once(["mediaPlaying", "mediaError"], e => (e.type === "mediaError" ? promise.reject() : promise.resolve()))

    /* Library Code */
    try {
      const params = __.media._convertDVB(__.media.source)
      const dvb = {}
      switch (params.broadcastType) {
        case "DVBC":
          Object.assign(dvb, {
            broadcastStandard: "DVB",
            channelType: "CDTV",
            frequency: parseFloat(params.frequency) * 1000,
            modulationType: "QAM256",
            bandwidth: "8Mhz",
            symbolRate: parseInt(params.symbolRate),
            programNumber: parseInt(params.programNumber),
            major: 1
          })
          break
        case "DVBT":
          Object.assign(dvb, {
            broadcastStandard: "DVB",
            channelType: "DTV",
            frequency: parseFloat(params.frequency) * 1000,
            modulationType: "QAM256",
            bandwidth: "8Mhz",
            programNumber: parseInt(params.programNumber),
            major: 2
          })
          break
        case "DVBT2":
          Object.assign(dvb, {
            broadcastStandard: "DVB",
            channelType: "DTV",
            frequency: parseFloat(params.frequency) * 1000,
            modulationType: "OFDM_T2",
            bandwidth: "8Mhz",
            programNumber: parseInt(params.programNumber),
            major: 2
          })
          break
        case "DVBS":
          Object.assign(dvb, {
            broadcastStandard: "DVB",
            channelType: "SDTV",
            frequency: parseFloat(params.frequency) * 1000,
            modulationType: "QPSK",
            bandwidth: "8Mhz",
            symbolRate: parseInt(params.symbolRate),
            satelliteId: this._satellites[parseInt(params.satelliteID) - 1],
            programNumber: parseInt(params.programNumber),
            polarization: this._polarization[params.polarization] || "POL_VL"
          })
          break
        case "ANALOG":
          Object.assign(dvb, {
            broadcastStandard: "DVB",
            channelType: "ATV",
            frequency: parseFloat(params.frequency),
            modulationType: "PAL",
            soundSystem: "AUTO",
            colorsSystem: "AUTO"
          })
          break
      }
      __._event._setVideoSize()
      b2bapis.b2bbroadcast.tuneDirect(dvb, () => {})
    } catch (error) {
      promise.reject(error.message)
    }
    /* Library Code */

    return promise.done
  }
  stop = async () => {
    let promise = await _$.progress.create(_$.progress.type.STOP)

    _$.vue.$once(["mediaStopped", "mediaError"], e => (e.type === "mediaError" ? promise.reject() : promise.resolve()))

    /* Library Code */
    try {
      tizen.tvwindow.hide(() => _$.handler.emit("media_event", "stop"), null, "MAIN")
    } catch (error) {
      promise.reject(error.message)
    }
    /* Library Code */

    return promise.done
  }
  pause = async () => {
    return true
  }
  continue = async () => {
    return true
  }

  /* Control Helpers */
  isSeekable = async () => {
    return false
  }
  getDuration = async () => {
    return 0
  }
  getPosition = async () => {
    return 0
  }
  setPosition = async () => {
    return false
  }

  /* Language and Subtitles Helpers */
  getSubtitles = async () => {
    try {
      /* Library Code */
      let subtitles = b2bapis.b2bbroadcast.getTotalSubtitleInfo().filter((value, index, self) => {
          return self.findIndex(v => v.language === value.language) === index && value.language !== "yyy"
        }),
        hasCurrent = b2bapis.b2bbroadcast.getCurrentSubtitle()
      /* Library Code */

      subtitles = subtitles.map(subtitle => {
        return { key: subtitle.index, value: subtitle.language, selected: subtitle.index === hasCurrent.index }
      })

      if (!subtitles.length) return false
      else subtitles.unshift({ key: "off", value: "None", selected: !hasCurrent.index })

      return subtitles
    } catch (error) {
      return false
    }
  }
  setSubtitle = async pid => {
    if (pid === "off" || pid === -1) {
      webapis.tvinfo.setMenuValue(webapis.tvinfo.TvInfoMenuKey.SUBTITLE_ONOFF_KEY, webapis.tvinfo.TvInfoMenuValue.OFF, () => {})
      return true
    }

    b2bapis.b2bbroadcast.setCurrentSubtitleIndex(parseInt(pid), () => {})
    webapis.tvinfo.setMenuValue(webapis.tvinfo.TvInfoMenuKey.SUBTITLE_ONOFF_KEY, webapis.tvinfo.TvInfoMenuValue.ON, () => {})
    return true
  }
  closeSubtitle = async () => {
    return this.setSubtitle(-1)
  }

  getLanguages = async () => {
    try {
      /* Library Code */
      let audios = b2bapis.b2bbroadcast.getTotalAudioInfo().filter((value, index, self) => {
          return self.findIndex(v => v.language === value.language) === index && value.language !== "yyy"
        }),
        hasCurrent = b2bapis.b2bbroadcast.getCurrentAudioInfo()
      /* Library Code */

      audios = audios.map(audio => {
        return { key: audio.index, value: audio.language, selected: audio.index === hasCurrent.index }
      })

      if (!audios.length) return false
      else return audios
    } catch (error) {
      return false
    }
  }
  setLanguage = async pid => {
    b2bapis.b2bbroadcast.setCurrentAudio(parseInt(pid), 0, () => {})
    return true
  }
}

export default Rf
